import { render, staticRenderFns } from "./CounterpartsRankingCard.vue?vue&type=template&id=168b66ba&scoped=true"
import script from "./CounterpartsRankingCard.vue?vue&type=script&lang=js"
export * from "./CounterpartsRankingCard.vue?vue&type=script&lang=js"
import style0 from "./CounterpartsRankingCard.vue?vue&type=style&index=0&id=168b66ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168b66ba",
  null
  
)

export default component.exports